import React from 'react'
import GroupTable from './GroupTable'
import { Input, Button } from 'semantic-ui-react'
import { Loader } from 'shared/components/Loader'
import { TooltipLabel } from 'components/TooltipLabel'

const GroupContent = ({
  topicGroupDataLoading,
  handleSwitchTab,
  tabName,
  handleSearch,
  pagination,
  searchText,
  filteredDataSource,
  handleEditAction,
  handlePageChange,
  allowAdminOrAbove,
  handleDelete,
}) => {
  return (
    <React.Fragment>
      <div className="flex justify-between items-center py-4">
        <h3 className="m-0">
          Topic groups
          <TooltipLabel
            className="tooltip"
            descriptionTitle="Topic groups"
            descriptionContent={`
Topic groups are broad categories that topics can belong to, helping you organize and create 
reports for different categories. A single topic can belong to multiple groups, 
offering flexibility in reporting and analysis.
  Note that topic groups do not affect the auto topic detection model.
`}
          />
        </h3>
        <div className="flex">
          <Input
            icon="far fa-magnifying-glass"
            placeholder="Search"
            className="mx-2 w-72"
            iconPosition="left"
            value={searchText.topicGroup}
            onChange={(e) => {
              handleSearch(e, 'topicGroup')
            }}
            disabled={topicGroupDataLoading}
          />
          <Button.Group basic size="small">
            <Button active={tabName === 'topic'} onClick={() => handleSwitchTab('topic')}>
              Topics
            </Button>
            <Button active={tabName === 'group'} onClick={() => handleSwitchTab('group')}>
              Groups
            </Button>
          </Button.Group>
        </div>
      </div>

      {topicGroupDataLoading ? (
        <Loader withContainer />
      ) : (
        <GroupTable
          dataSource={filteredDataSource.topicGroup.slice(
            (pagination.topicGroup.current - 1) * pagination.topicGroup.pageSize,
            pagination.topicGroup.current * pagination.topicGroup.pageSize
          )}
          handleEditAction={handleEditAction}
          total={filteredDataSource.topicGroup.length}
          handlePageChange={handlePageChange}
          paginationCurrent={pagination.topicGroup.current}
          paginationPageSize={pagination.topicGroup.pageSize}
          allowAdminOrAbove={allowAdminOrAbove}
          handleDelete={handleDelete}
        />
      )}
    </React.Fragment>
  )
}

export default GroupContent



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Topics/GroupContent.js